module.exports = __webpack_public_path__ + "img/logo-on-dark-removebg.b0567f19.png";